const publicPages = [
  'login',
  'callback'
]
export default publicPages;